/* auth */
import { cfg } from '../../../config';
import { http } from '../http';
import { type ApiRsp } from '../types';

interface AuthService {
    getToken(params: ReqToken): Promise<ApiRsp>;
    getUserInfo(token?: string): Promise<ApiRsp>;
}

export const auth: AuthService = {
    getToken: (params: ReqToken) => {
        const url = cfg.hub.OAUTH + `/token`;
        return http.post(url, params);
    },
    getUserInfo: (token?: string) => {
        let url = cfg.hub.OAUTH + `/userinfo`;
        if (token) url += `?token=${token}`;
        return http.get(url);
    },
};

export type ReqToken = {
    grant_type: string;
    client_id: string;
    client_secret?: string;
    username?: string;
    password?: string;
    refresh_token?: string;
    code?: string;
    uuid?: string;
};
export type RspToken = {
    access_token: string;
    token_type: string;
    expires_in: number;
    refresh_token?: string;
    redirect_uri?: string;
};
export type UserInfo = {
    sub: number;
    name: string;
    utyp: string;
    unit: string;
    unit_id: number;
    role_id: number;
    metadata?: {
        emp_type: string;
        emp_level: string;
        position: string;
    },
    picture?: string;
    updated_at: number;
};